import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneArrangement } from 'src/app/interfaces/gemstone-arrangement';

@Injectable({
  providedIn: 'root'
})
export class StoneArrangementsProviderService extends APIProviderService<GemstoneArrangement> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/Arrangements`;
  }
}
